/**
 * Created by vadim.m on 10/13/2017.
 */
export enum EmailTemplateType{
    OrderToCustomer,
    AgentNotification,
    OrderToCustomerPay,
    BBFeeChanged = 3,
    AmazonSellerDefault = 4,
    AmazonSellerRegistered = 5,
    AmazonBNSubmitted = 6,
    AmazonProductsCompleted = 7,
    CreditCardRequest = 8,
    CreditCardDontWork = 9,
    CustomChargesHaveBeenPaid = 10,
    CanadaPageMonitorNotification = 11,
    UpdatePaymentData = 12,
    PayPalPaymentRequest = 13,
    CreditCardExistingCustomerRequest = 14
}



// WEBPACK FOOTER //
// ./app/objects/email/emailTemplateType.ts